import * as React from "react";
const SvgFiRrTachometerAltSlow = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M20 4.052a12 12 0 0 0-16.388 17.52A5 5 0 0 0 7.12 23h9.767a4.84 4.84 0 0 0 3.354-1.288A12.053 12.053 0 0 0 20 4.052M18.868 20.26c-.542.491-1.25.756-1.981.741H7.12a3 3 0 0 1-2.11-.858 10 10 0 1 1 13.858.117M20 13a7.93 7.93 0 0 1-2.408 5.715 1 1 0 1 1-1.4-1.43c4.14-3.956.6-11.095-5.05-10.223a1 1 0 0 1-.286-1.98A8.026 8.026 0 0 1 20 13M7.806 17.284a1.002 1.002 0 0 1-1.4 1.432 7.97 7.97 0 0 1-2.327-6.859 1 1 0 0 1 1.98.286 5.97 5.97 0 0 0 1.747 5.141M14 13a1.999 1.999 0 1 1-3.932-.518L6.293 8.707a1 1 0 0 1 1.414-1.414l3.775 3.775A2.008 2.008 0 0 1 14 13"
    />
  </svg>
);
export default SvgFiRrTachometerAltSlow;
